import React from "react";
import { Switch, Route } from "react-router-dom";

import WOProcessingsPage from "./WOProcessingPage";

const WOProcessingRouter = () => (
  <Switch>
    <Route path="/fleet/work-orders-processing">
      <WOProcessingsPage />
    </Route>
  </Switch>
);

export default WOProcessingRouter;
